import React from 'react';
import { Webhook } from 'lucide-react';
import { Text } from '@cotera/client/app/components/ui';
import type { WorkflowRenderView } from '../../../workflow-render-catalog/types';
import { asRecord, readString } from '../../utils';
import type { WorkflowNodeViewData } from '../types';

/** Persisted `type` of the synthetic run-input node materialized for each run. */
export const WORKFLOW_RUN_INPUT_NODE_TYPE = 'system/run-input';

/**
 * The synthetic `system/run-input` entry node present in every run's definition
 * graph. It carries the run's trigger input as its output; rendered as a simple
 * input/trigger card so the run graph doesn't fall back to the "unknown" node.
 *
 * Title prefers the run's trigger name (merged into `data.name` from the graph
 * API) so the card matches the workflows / runs-list trigger label.
 */
export const runInputNodeStrategy: WorkflowRenderView<WorkflowNodeViewData> = {
  accent: 'trigger',
  badge: 'Input',
  getTitle: (node) => {
    const name = readString(asRecord(node.data), 'name');
    return name !== undefined && name !== '' ? name : 'Run input';
  },
  getDescription: () => 'Trigger input for this run',
  renderIcon: () => <Webhook className="h-4 w-4" />,
  renderBody: () => (
    <Text.Caption className="text-muted-foreground block">
      The input this run started with.
    </Text.Caption>
  ),
};
